import React from 'react';
import { useTranslation } from 'context/LanguageContext';

const ColorSelector = ({ 
  colors, 
  selectedColor,
  onColorSelect
}) => {
  const hasColors = colors && Array.isArray(colors) && colors.length > 0;
  const { t } = useTranslation();

  if (!hasColors) return null;

  return (
    <div className="mb-6">
      <label className="block text-sm font-semibold text-gray-900 mb-3">
        {t("selectColor")} <span className="text-red-500">*</span>
      </label>
      
      {/* Color Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
        {colors.map((color, index) => (
          <button
            key={index}
            onClick={() => onColorSelect(color)}
            className={`
              py-1.5 px-2
              sm:py-2 sm:px-3
              rounded-md
              border-2 font-medium
              text-xs sm:text-sm md:text-base
              transition-all duration-200
              truncate
              ${selectedColor === color
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
              }
            `}
            title={color}
          >
            {color}
          </button>
        ))}
      </div>

      {/* Selected color indicator */}
      {selectedColor && (
        <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-700">
            {t("selectedColor")}: <span className="font-semibold">{selectedColor}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default ColorSelector;
